import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';

interface DisconnectArgs {
  socialAccountId: number;
}

export function useOutlookDisconnect(orgId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ socialAccountId }: DisconnectArgs) => {
      if (!orgId) {
        throw new Error('No org selected');
      }
      return apiPost('/users/api/social-connections/disconnect/', {
        account_id: socialAccountId,
        org_id: Number(orgId),
      });
    },
    onSuccess: () => {
      if (orgId) {
        queryClient.invalidateQueries({
          queryKey: ['microsoft', 'outlook', 'status', orgId],
        });
      }
    },
  });
}
